<!-- #D39 -->
<!-- #S97 -->
<!-- #D40 -->
<template>
  <div v-if="!promotionProcessing || overrideTextRegular">
    <div v-if="overrideTextRegular" v-html="overrideTextRegular"></div>
    <div v-else>
      <div v-if="price.priceDisplay">
        <div>
          <span v-if="!price.isExact">{{ $t('common.price_from') }} </span>
          <VFormatted :price="price" :disabled="noFormatting" :class="noFormatting ? 'text-bold' : 'text-brand price'" />
          <span v-if="price.chargingIntervalOverrideText">
            {{ price.chargingIntervalOverrideText }}
          </span>
          <span v-else-if="subscriptionType === 2">
            {{ $t('common.charging_onetime') }}
          </span>
          <span v-else>
            {{ chargingInterval(price.chargingIntervalUnit, price.chargingIntervalFactor) }}
          </span>
        </div>
        <div v-if="setupProcessing && price.setupPrice">
          {{ fromFirstUnit(price.chargingIntervalUnit, 'onetime') }} <span class="price text-brand">{{ price.setupPrice.priceDisplay }}</span>
        </div>
      </div>
      <div v-else>
        <strong>{{ $t('common.free_of_charge') }}</strong>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="overrideTextPromotion" v-html="overrideTextPromotion"></div>
    <div v-else>
      <div v-if="price.promotion">
        <div v-if="price.promotion.priceDisplay">
          <span v-if="!price.isExact">{{ $t('common.price_from') }} </span>
          <VFormatted :price="price.promotion" :disabled="noFormatting" :class="noFormatting ? 'text-bold' : 'text-brand price'" />
          <span v-if="price.promotion.durationFactor > 0">
            {{ chargingInterval(price.promotion.durationUnit, price.promotion.durationFactor) }}
          </span>
          <span v-else>
            {{ chargingInterval(price.chargingIntervalUnit, price.chargingIntervalFactor) }}
          </span>
        </div>
        <div v-else>
          <strong>{{ $t('common.free_of_charge') }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chargingInterval, fromFirstUnit } from '@/utils/price';
import VFormatted from './Formatted';

export default {
  name: 'Price',

  components: {
    VFormatted,
  },

  props: {
    price: {
      type: Object,
      required: true,
    },

    promotionProcessing: {
      type: Boolean,
      required: false,
    },

    setupProcessing: {
      type: Boolean,
      required: false,
    },

    overrideTextRegular: {
      type: String,
      required: false,
      default: null,
    },

    overrideTextPromotion: {
      type: String,
      required: false,
      default: null,
    },

    noFormatting: {
      type: Boolean,
      required: false,
    },

    subscriptionType: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  methods: {
    chargingInterval,
    fromFirstUnit,
  },
};
</script>
